import API from './axiosInstance';

const API_PATH = '/nav-visibility-preferences';

export const getNavVisibilityPreferences = (companyId) =>
	API.get(API_PATH, { params: { companyId } });

export const updateNavVisibilityPreferences = (companyId, hiddenItemIds) =>
	API.put(API_PATH, { hiddenItemIds }, { params: { companyId } });

export const resetNavVisibilityPreferences = (companyId) =>
	API.delete(API_PATH, { params: { companyId } });
